import type { MySsException } from '~/types/MySsException';

import { formatToISODate } from '@scansource-brazil/zeus-core-ui/date';
import { removeMasks } from '@scansource-brazil/zeus-core-ui/string';
import { IOrderDTO } from '~/models/Orders';
import httpService from './httpService';

const get = httpService.get;
const baseUrl = 'orders';

export async function getOrders(resellerDocument: string, params?: any) {
  if (!resellerDocument) throw new Error('RESELLER_DOCUMENT_REQUIRED');
  return await get(baseUrl, { params: { ...params, resellerDocument } }).then(
    ({ data }) => {
      const items = data.data;
      const pagination = data.metadata.pagination;
      return {
        orderList: items.map((orderDto: IOrderDTO) => new Order(orderDto)),
        pagination,
      };
    },
    (error) => {
      throw error;
    },
  );
}

export const listOrders = getOrders;

export async function listOrderItems(orderNumber: string | number, resellerDocument: string) {
  return await get(`${baseUrl}/${orderNumber}/items`, { params: { resellerDocument } }).then(
    (response) => adaptOrderItems.fromAPI(response.data.data),
    (error: MySsException) => {
      throw error;
    },
  );
}

export async function filterOrders(
  resellerDocument: string,
  filters: Record<string, any>,
  pagination = { ...PAGINATION },
) {
  try {
    const params = adaptQueryParams<any, any>(filters, pagination, prepareOrderFilterQueryParams);
    return await getOrders(resellerDocument, params);
  } catch (error: any) {
    const err = errorTreatment(error);
    throw err;
  }
}

export async function showOrder(resellerDocument: string, orderNumber: string) {
  return await get(`${baseUrl}/${orderNumber}`, { params: { resellerDocument } }).then(
    (response) => (response?.data?.data ? new Order(response.data.data) : null),
    (error) => {
      throw error;
    },
  );
}

export async function showLastOrder(resellerDocument: string) {
  return await get(`${baseUrl}/${resellerDocument}/latest`).then((response) => {
    return new Order(response.data.data);
  });
}

export async function downloadOrderStatement(orderNumber: string, resellerDocument: string) {
  return await get(`${baseUrl}/${orderNumber}/export`, {
    params: { resellerDocument },
    responseType: 'blob',
  }).then(
    ({ data }: any) => {
      downloadFileBlob(data, `Extrato_${orderNumber}.xlsx`);
    },
    (error: any) => {
      console.error(error);
    },
  );
}

export async function downloadAllOrders(
  resellerDocument: string,
  filters: any,
  pagination = { ...PAGINATION },
) {
  try {
    const params = removePagination(
      adaptQueryParams<any, any>(filters, pagination, prepareOrderFilterQueryParams),
    );
    params.resellerDocument = resellerDocument;
    return await get('orders/export', { params, responseType: 'blob' }).then(
      ({ data }: any) => {
        downloadFileBlob(
          data,
          `ORDERS_${resellerDocument}_${removeMasks(formatToISODate(new Date(Date.now())))}.xlsx`,
        );
      },
      (error: any) => {
        console.error(error);
      },
    );
  } catch (error: any) {
    const err = errorTreatment(error);
    throw err;
  }
}
